
import { defineAsyncComponent } from "vue";
import { Options, Vue } from "vue-class-component";
import { FlagsPermissionBulkBookingV2 } from "@/feature-flags/flags-bulk-booking-v2";

const BulkBookingCreateRetail = defineAsyncComponent({
  loader: () => import("./create-retail.vue")
});
const BulkBookingCreateClient = defineAsyncComponent({
  loader: () => import("./create-client.vue")
});
const BulkBookingCreateInternal = defineAsyncComponent({
  loader: () => import("./create-internal.vue")
});
import { permissionBulkBooking } from "./modules/utils";

@Options({
  components: {
    BulkBookingCreateRetail,
    BulkBookingCreateClient,
    BulkBookingCreateInternal
  }
})
export default class LayoutCreate extends Vue {
  get utilsBulkBooking() {
    return permissionBulkBooking;
  }

  get flagsBulkBookingInternal() {
    return FlagsPermissionBulkBookingV2.feature_bulk_booking_internal_v2.isEnabled();
  }
}
